import { lazyImport } from '@/utils/lazyImport';
import { GOOGLE_CLIENT_ID, APP_PATH, SCOPE } from '@/config';
const { AuthRoutes } = lazyImport(() => import('@/features/auth'), 'AuthRoutes');
export const publicRoutes = [
  {
    path: '/*',
    element: <AuthRoutes />,
  },
];
